import { AxiosError } from 'axios'
import { z } from 'zod'

import { ValidationProblemDetails } from '@/gen/publicApi'

export function mapProblemDetailErrors(error: AxiosError, errorMap: any) {
    const errorData = error.response?.data as ValidationProblemDetails | undefined

    if (!errorData || !errorData.errors) return {}

    for (const prop of Object.getOwnPropertyNames(errorData.errors)) {
        const errors = errorData.errors[prop]
        const newProp = prop[0].toLowerCase() + prop.slice(1)
        errorMap[newProp] = {
            type: 'validation',
            message: errors.join(' '),
        }
    }
}

export const passwordSchema = z
    .object({
        password: z
            .string()
            .min(8, 'Minimum 8 characters')
            .refine(password => {
                const containsUppercase = (ch: string) => /[A-Z]/.test(ch)
                const containsLowercase = (ch: string) => /[a-z]/.test(ch)
                const containsSpecialChar = (ch: string) => /[`!@#$%^&*()_\-+=[\]{};':"\\|,.<>/?~ ]/.test(ch)
                let countOfUpperCase = 0,
                    countOfLowerCase = 0,
                    countOfNumbers = 0,
                    countOfSpecialChar = 0

                for (let i = 0; i < password.length; i++) {
                    const ch = password.charAt(i)
                    if (!isNaN(+ch)) countOfNumbers++
                    else if (containsUppercase(ch)) countOfUpperCase++
                    else if (containsLowercase(ch)) countOfLowerCase++
                    else if (containsSpecialChar(ch)) countOfSpecialChar++
                }

                return countOfLowerCase > 0 && countOfUpperCase > 0 && countOfSpecialChar > 0 && countOfNumbers > 0
            }, 'Password must contain at least one upper case, one lower case, one number and one special character.'),
        passwordConfirm: z.string().min(8, 'Minimum 8 characters'),
    })
    .refine(data => data.passwordConfirm === data.password, {
        message: 'Passwords do not match',
        path: ['passwordConfirm'],
    })
